import axios from 'axios';
import store from '@/store';
import _ from 'lodash';

const apiPath = `${store.state.apiPathWithVersion}/subscription`;

export default {
  async create(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/create?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async buy(method, params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.callbackUrl = window.location.origin;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/${method}?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async buyAddonPayments(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.callbackUrl = window.location.toString();
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/addonPayments?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  canBuySubcription() {
    let exists = _.find(
      store.state.user.roles,
      it => it.authority === 'ROLE_BUY_SUBSCRIPTION'
    );
    return typeof exists !== 'undefined';
  }
};
